module.exports = __webpack_public_path__ + "static/media/12UNCTAD19.b84e183d.jpg";